module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_el_greek-f4f1efd04d192aac3cbe69e75c994783.svg";